import * as React from 'react'
import {
  ArticleCallNowCardContainer,
  ArticleCallNowCardContent,
  ArticleCallNowCardSubtitle,
  ArticleCallNowStyledCard,
  StyledButton,
  btnStyles,
} from "@pages/Homepage/components/ArticleCallNowCard/ArticleCallNowCard.elements"
import {CardTitle} from "@css/common.elements"
import {PhoneNumber} from "@components/PhoneNumber"
import {getPhoneNumber} from "@lib/PhoneNumber"
import Analytics from "@lib/Analytics"
import Pixels from '@lib/Pixels'

export type ArticleCallNow = {
  title: string
  hours: string
  phoneMapping: PhoneMapping
}

export const ArticleCallNowCard: React.FunctionComponent<ArticleCallNow> = ({title, hours, phoneMapping}) => {

  const onClickCall = () => {
    const number = getPhoneNumber(phoneMapping);
    Pixels.callEvent()
    Analytics.log('Click To Call', {
      location: 'article-call-widget', info: `tel:${ number }`
    });
    window.location.href = `tel:${ number }`;
  }


  return (
    <ArticleCallNowCardContainer>
      <ArticleCallNowStyledCard>
        <ArticleCallNowCardContent>
          <CardTitle dangerouslySetInnerHTML={{__html: title}}/>
          <StyledButton
            onClick={onClickCall}
            variant="green"
            css={btnStyles}
          >
            CALL HEALTH IQ NOW
          </StyledButton>
          <PhoneNumber mapping={phoneMapping} format='pretty'/>
          <ArticleCallNowCardSubtitle
            dangerouslySetInnerHTML={{__html: hours}}/>
        </ArticleCallNowCardContent>
      </ArticleCallNowStyledCard>
    </ArticleCallNowCardContainer>
  )
}
